<template>
  <svg
    class="fill-current"
    :height="size"
    :width="width"
    viewBox="0 0 14 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 13C4.0875 13 3.73438 12.8531 3.44062 12.5594C3.14687 12.2656 3 11.9125 3 11.5V1.5C3 1.0875 3.14687 0.734376 3.44062 0.440626C3.73438 0.146876 4.0875 0 4.5 0H12.5C12.9125 0 13.2656 0.146876 13.5594 0.440626C13.8531 0.734376 14 1.0875 14 1.5V11.5C14 11.9125 13.8531 12.2656 13.5594 12.5594C13.2656 12.8531 12.9125 13 12.5 13H4.5ZM4.5 11.5H12.5V1.5H4.5V11.5ZM1.5 16C1.0875 16 0.734375 15.8531 0.440625 15.5594C0.146875 15.2656 0 14.9125 0 14.5V3.75C0 3.5375 0.0714514 3.35937 0.214354 3.21562C0.357271 3.07187 0.534354 3 0.745604 3C0.956868 3 1.13542 3.07187 1.28125 3.21562C1.42708 3.35937 1.5 3.5375 1.5 3.75V14.5H10.25C10.4625 14.5 10.6406 14.5715 10.7844 14.7144C10.9281 14.8573 11 15.0344 11 15.2456C11 15.4569 10.9281 15.6354 10.7844 15.7812C10.6406 15.9271 10.4625 16 10.25 16H1.5Z"
      class="copy"
    />
  </svg>
</template>

<script>
export default {
  name: 'CopyInputIcon',

  props: {
    size: {
      type: [Number, String],
      default: 16
    }
  },

  computed: {
    width() {
      return Number(this.size) * 14 / 16
    }
  }
}
</script>

